const mentalCapacityOptions = [
  {
    value: 'yes',
    label: 'Yes',
  },
  { value: 'no', label: 'No' },
  { value: 'unknown', label: 'Unknown' },
];

const haveLPAOptions = [
  {
    value: 'yes',
    label: 'Yes',
  },
  { value: 'no', label: 'No' },
  { value: 'notSure', label: 'Not Sure' },
];

export { mentalCapacityOptions, haveLPAOptions };
